<section class="card highlights top-pad bottom-pad" aria-label="Highlight">
  <div class="row">
    <div class="col-fit justify-content-center">
      @switch (true) {
        @case (highlight.attributes.category === HighlightCategory.ANNOUNCEMENT) {
          <img src="/assets/images/announcement.png" alt="Announcement" aria-label="announcement" class="">
        }
        @case (highlight.attributes.category === HighlightCategory.SUCCESSSTORY) {
          <img src="/assets/images/success_story.png" alt="Success Story" aria-label="success story" class="">
        }
        @case (highlight.attributes.category === HighlightCategory.TRAINING) {
          <img src="/assets/images/training.png" alt="Training" aria-label="training" class="">
        }
        @case (highlight.attributes.category === HighlightCategory.MAINTENANCE) {
          <img src="/assets/images/maintenance.png" alt="Maintenance" aria-label="maintenance" class="">
        }
        @default {
          <img src="/assets/images/CIR_Logo_Small.png" alt="CIR" aria-label="CIR Default Highlight Image" class="">
        }
      }
    </div>
    <div class="col">
      <div class="row align-items-stretch">
        <div class="col highlight-detail-container">
          <h1 class="highlights__heading">{{ highlight.attributes.subject }}</h1>
          <p aria-label="highlight detail" [innerHTML]="highlight.attributes.description"></p>
        </div>
      </div>
      @if (highlight.attributes.hasLink) {
        <div class="row link justify-content-end align-items-center">
          <a [attr.href]="highlight.attributes.link.href"
            role="button"
            aria-label="Read more about this highlight in the attached pdf"
            class="col-fit minor padded">Read More<i class="far fa-chevron-right right-icon"></i></a>
        </div>
      }
      </div>
  </div>
</section>
